import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  BUDGET_DEBTS_TABLE_ARIA_LABEL,
  BUDGET_DEBTS_TABLE_COLUMN_WIDTHS,
  BUDGET_DEBTS_TABLE_HEADERS,
  BUDGET_DEBTS_TABLE_MIN_WIDTH,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/budgetDebts/constants.ts';
import { BudgetDebtRow } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/budgetDebts/BudgetDebtRow.tsx';
import { FinancialConditionTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTable.tsx';
import type { IBudgetDebtsSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/budgetDebts/types.ts';
import type { TFinancialConditionFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { createBudgetDebt } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const BudgetDebtsSection: React.FC<IBudgetDebtsSectionProps> = ({
  disabled,
  borrowerType,
  sectionNumber,
}) => {
  const { control, watch } = useFormContext<TFinancialConditionFormValues>();
  const currentBorrowerType = watch('borrowerType')?.value;
  const { fields, append, remove } = useFieldArray({ control, name: 'budgetDebts' });

  if (currentBorrowerType !== borrowerType) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        {sectionNumber}. Заборгованість перед бюджетом
      </Typography>
      <FinancialConditionTable
        ariaLabel={BUDGET_DEBTS_TABLE_ARIA_LABEL}
        headers={[...BUDGET_DEBTS_TABLE_HEADERS]}
        showActions={fields.length > 1}
        columnWidths={[...BUDGET_DEBTS_TABLE_COLUMN_WIDTHS]}
        minWidth={BUDGET_DEBTS_TABLE_MIN_WIDTH}
      >
        {fields.map((field, index) => (
          <BudgetDebtRow
            key={field.id}
            index={index}
            canRemove={fields.length > 1}
            disabled={disabled}
            onRemove={() => remove(index)}
          />
        ))}
      </FinancialConditionTable>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => append(createBudgetDebt())}
        disabled={disabled}
        sx={documentGenerationFormStyles.addButton}
      >
        Додати заборгованість
      </Button>
    </Box>
  );
};
